export const blogData = [
  {
    id: 1,
    title: "iPhone 9",
    description: "An apple mobile which is nothing lorem like apple",
    price: 549,
    discountPercentage: 12.96,
    rating: 4.69,
    stock: 94,
    brand: "Apple",
    category: "smartphones",
    thumbnail: "https://i.dummyjson.com/data/products/1/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/1/1.jpg",
      "https://i.dummyjson.com/data/products/1/2.jpg",
      "https://i.dummyjson.com/data/products/1/3.jpg",
      "https://i.dummyjson.com/data/products/1/4.jpg",
      "https://i.dummyjson.com/data/products/1/thumbnail.jpg",
    ],
  },
  {
    id: 2,
    title: "iPhone X",
    description:
      "SIM-Free, Model A19211 6.5-inch Super Retina HD display with OLED technology A12 Bionic chip with ...",
    price: 899,
    discountPercentage: 17.94,
    rating: 4.44,
    stock: 34,
    brand: "Apple",
    category: "smartphones",
    thumbnail: "https://i.dummyjson.com/data/products/2/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/2/1.jpg",
      "https://i.dummyjson.com/data/products/2/2.jpg",
      "https://i.dummyjson.com/data/products/2/3.jpg",
      "https://i.dummyjson.com/data/products/2/thumbnail.jpg",
    ],
  },
  {
    id: 3,
    title: "Samsung Universe 9",
    description:
      "Samsung's new variant which goes beyond Galaxy to the Universe",
    price: 1249,
    discountPercentage: 15.46,
    rating: 4.09,
    stock: 36,
    brand: "Samsung",
    category: "smartphones",
    thumbnail: "https://i.dummyjson.com/data/products/3/thumbnail.jpg",
    images: ["https://i.dummyjson.com/data/products/3/1.jpg"],
  },
  {
    id: 4,
    title: "OPPOF19",
    description: "OPPO F19 is officially announced on April 2021.",
    price: 280,
    discountPercentage: 17.91,
    rating: 4.3,
    stock: 123,
    brand: "OPPO",
    category: "smartphones",
    thumbnail: "https://i.dummyjson.com/data/products/4/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/4/1.jpg",
      "https://i.dummyjson.com/data/products/4/2.jpg",
      "https://i.dummyjson.com/data/products/4/3.jpg",
      "https://i.dummyjson.com/data/products/4/4.jpg",
      "https://i.dummyjson.com/data/products/4/thumbnail.jpg",
    ],
  },
  {
    id: 5,
    title: "Huawei P30",
    description:
      "Huawei’s re-badged P30 Pro New Edition was officially unveiled yesterday in Germany and now the device has made its way to the UK.",
    price: 499,
    discountPercentage: 10.58,
    rating: 4.09,
    stock: 32,
    brand: "Huawei",
    category: "smartphones",
    thumbnail: "https://i.dummyjson.com/data/products/5/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/5/1.jpg",
      "https://i.dummyjson.com/data/products/5/2.jpg",
      "https://i.dummyjson.com/data/products/5/3.jpg",
    ],
  },
  {
    id: 6,
    title: "MacBook Pro",
    description:
      "MacBook Pro 2021 with mini-LED display may launch between September, November",
    price: 1749,
    discountPercentage: 11.02,
    rating: 4.57,
    stock: 83,
    brand: "Apple",
    category: "laptops",
    thumbnail: "https://i.dummyjson.com/data/products/6/thumbnail.png",
    images: [
      "https://i.dummyjson.com/data/products/6/1.png",
      "https://i.dummyjson.com/data/products/6/2.jpg",
      "https://i.dummyjson.com/data/products/6/3.png",
      "https://i.dummyjson.com/data/products/6/4.jpg",
    ],
  },
  {
    id: 7,
    title: "Samsung Galaxy Book",
    description:
      "Samsung Galaxy Book S (2020) Laptop With Intel Lakefield Chip, 8GB of RAM Launched",
    price: 1499,
    discountPercentage: 4.15,
    rating: 4.25,
    stock: 50,
    brand: "Samsung",
    category: "laptops",
    thumbnail: "https://i.dummyjson.com/data/products/7/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/7/1.jpg",
      "https://i.dummyjson.com/data/products/7/2.jpg",
      "https://i.dummyjson.com/data/products/7/3.jpg",
      "https://i.dummyjson.com/data/products/7/thumbnail.jpg",
    ],
  },
  {
    id: 8,
    title: "Microsoft Surface Laptop 4",
    description:
      "Style and speed. Stand out on HD video calls backed by Studio Mics. Capture ideas on the vibrant touchscreen.  Stand out on HD video calls backed by Studio Mics. Capture ideas on the vibrant touchscreen.  Stand out on HD video calls backed by Studio Mics. Capture ideas on the vibrant touchscreen.  Stand out on HD video calls backed by Studio Mics. Capture ideas on the vibrant touchscreen.",
    price: 1499,
    discountPercentage: 10.23,
    rating: 4.43,
    stock: 68,
    brand: "Microsoft Surface",
    category: "laptops",
    thumbnail: "https://i.dummyjson.com/data/products/8/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/8/1.jpg",
      "https://i.dummyjson.com/data/products/8/2.jpg",
      "https://i.dummyjson.com/data/products/8/3.jpg",
      "https://i.dummyjson.com/data/products/8/4.jpg",
      "https://i.dummyjson.com/data/products/8/thumbnail.jpg",
    ],
  },
  {
    id: 9,
    title: "Infinix INBOOK",
    description:
      "Infinix Inbook X1 Ci3 10th 8GB 256GB Infinix Inbook X1 Ci3 10th 8GB 256GB Infinix Inbook X1 Ci3 10th 8GB 256GB 14 Win10 Grey – 1 Year Warranty",
    price: 1099,
    discountPercentage: 11.83,
    rating: 4.54,
    stock: 96,
    brand: "Infinix",
    category: "laptops",
    thumbnail: "https://i.dummyjson.com/data/products/9/thumbnail.jpg",
    images: [
      "https://i.dummyjson.com/data/products/9/1.jpg",
      "https://i.dummyjson.com/data/products/9/2.png",
      "https://i.dummyjson.com/data/products/9/3.png",
      "https://i.dummyjson.com/data/products/9/4.jpg",
      "https://i.dummyjson.com/data/products/9/thumbnail.jpg",
    ],
  },
  {
    id: 10,
    title: "HP Pavilion 15-DK1056WM",
    description:
      "HP Pavilion 15-DK1056WM Gaming Laptop 10th Gen Core i5, 8GB, 256GB SSD, GTX 1650 4GB, Windows 10",
    price: 1099,
    discountPercentage: 6.18,
    rating: 4.43,
    stock: 89,
    brand: "HP Pavilion",
    category: "laptops",
    thumbnail: "https://i.dummyjson.com/data/products/10/thumbnail.jpeg",
    images: [
      "https://i.dummyjson.com/data/products/10/1.jpg",
      "https://i.dummyjson.com/data/products/10/2.jpg",
      "https://i.dummyjson.com/data/products/10/3.jpg",
      "https://i.dummyjson.com/data/products/10/thumbnail.jpeg",
    ],
  },
];

export const userData = [
  {
    id: 1,
    firstName: "Terry",
    lastName: "Medhurst",
    maidenName: "Smitham",
    age: 50,
    gender: "male",
    email: "atuny0@sohu.com",
    phone: "+63 791 675 8914",
    username: "atuny0",
    password: "9uQFF1Lh",
    birthDate: "2000-12-25",
    image: "https://robohash.org/hicveldicta.png",
  },
  {
    id: 2,
    firstName: "Sheldon",
    lastName: "Quigley",
    maidenName: "Cole",
    age: 28,
    gender: "male",
    email: "hbingley1@plala.or.jp",
    phone: "+7 813 117 7139",
    username: "hbingley1",
    password: "CQutx25i8r",
    birthDate: "2003-08-02",
    image: "https://robohash.org/doloremquesintcorrupti.png",
  },
  {
    id: 3,
    firstName: "Terrill",
    lastName: "Hills",
    maidenName: "Hoeger",
    age: 38,
    gender: "male",
    email: "rshawe2@51.la",
    phone: "+63 739 292 7942",
    username: "rshawe2",
    password: "OWsTbMUgFc",
    birthDate: "1992-12-30",
    image: "https://robohash.org/consequunturautconsequatur.png",
  },
  {
    id: 4,
    firstName: "Miles",
    lastName: "Cummerata",
    maidenName: "Maggio",
    age: 49,
    gender: "male",
    email: "yraigatt3@nature.com",
    phone: "+86 461 145 4186",
    username: "yraigatt3",
    password: "sRQxjPfdS",
    birthDate: "1969-01-16",
    image: "https://robohash.org/facilisdignissimosdolore.png",
  },
  {
    id: 5,
    firstName: "Mavis",
    lastName: "Schultz",
    maidenName: "Yundt",
    age: 38,
    gender: "male",
    email: "kmeus4@upenn.edu",
    phone: "+372 285 771 1911",
    username: "kmeus4",
    password: "aUTdmmmbH",
    birthDate: "1968-11-03",
    image: "https://robohash.org/adverovelit.png",
  },
  {
    id: 6,
    firstName: "Alison",
    lastName: "Reichert",
    maidenName: "Franecki",
    age: 21,
    gender: "female",
    email: "jtreleven5@nhs.uk",
    phone: "+351 527 735 3642",
    username: "jtreleven5",
    password: "zY1nE46Zm",
    birthDate: "1969-07-21",
    image: "https://robohash.org/laboriosamfacilisrem.png",
  },
  {
    id: 7,
    firstName: "Oleta",
    lastName: "Abbott",
    maidenName: "Wyman",
    age: 31,
    gender: "female",
    email: "dpettegre6@columbia.edu",
    phone: "+62 640 802 7111",
    username: "dpettegre6",
    password: "YVmhktgYVS",
    birthDate: "1982-02-21",
    image: "https://robohash.org/cupiditatererumquos.png",
  },
  {
    id: 8,
    firstName: "Ewell",
    lastName: "Mueller",
    maidenName: "Durgan",
    age: 29,
    gender: "male",
    email: "ggude7@chron.com",
    phone: "+86 946 297 2275",
    username: "ggude7",
    password: "MWwlaeWcOoF6",
    birthDate: "1964-08-24",
    image: "https://robohash.org/quiaharumsapiente.png",
  },
  {
    id: 9,
    firstName: "Demetrius",
    lastName: "Corkery",
    maidenName: "Gleason",
    age: 22,
    gender: "male",
    email: "nloiterton8@aol.com",
    phone: "+86 356 590 9727",
    username: "nloiterton8",
    password: "HTQxxXV9Bq4",
    birthDate: "1971-03-11",
    image: "https://robohash.org/excepturiiuremolestiae.png",
  },
  {
    id: 10,
    firstName: "Eleanora",
    lastName: "Price",
    maidenName: "Cummings",
    age: 37,
    gender: "female",
    email: "umcgourty9@jalbum.net",
    phone: "+60 184 408 0824",
    username: "umcgourty9",
    password: "i0xzpX",
    birthDate: "1958-08-11",
    image: "https://robohash.org/aliquamcumqueiure.png",
  },
];
